import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {OrganizationService} from '../../services/organization-service';
import {Organization} from '../../organization/organization';
import {RepDeactivation} from '../../model/rep-deactivation';
import {SelectionService} from '../../services/selection-service';
import {SelectionItem} from '../../selections/selection-item';
import {DateUtils} from '../../utils/date-utils';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from '@angular/material/datepicker';
import {MatInput} from '@angular/material/input';
import {MatOption} from '@angular/material/core';

import {FormsModule} from '@angular/forms';
import {MatSelect} from '@angular/material/select';
import {MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';

@Component({
    selector: 'app-deactivate-rep-dialog',
    templateUrl: './deactivate-rep-dialog.component.html',
    styleUrls: ['./deactivate-rep-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatButton, MatIcon]
})
export class DeactivateRepDialogComponent implements OnInit {
  private readonly organizationService = inject(OrganizationService);
  private readonly dialogRef = inject<MatDialogRef<DeactivateRepDialogComponent>>(MatDialogRef);
  private readonly selectionService = inject(SelectionService);
  private readonly data = inject(MAT_DIALOG_DATA);


  organization: Organization;
  readonly cancelDate = signal<Date>(undefined!);
  readonly newRepId = signal<string>(undefined!);
  readonly replacementReps = signal<SelectionItem[]>(undefined!);

  constructor() {
    const data = this.data;

    this.organization = data.organization;
  }

  ngOnInit(): void {
    this.selectionService.getActiveRepOffices().subscribe({
      next: (offices: SelectionItem[]) => {
        this.replacementReps.set(offices.filter(office => office.code !== this.organization.orgUnitId));
        this.newRepId.set('');
        this.cancelDate.set(new Date());
      }, error: () => this.dialogRef.close()
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  replaceRep(): void {
    const deactivation = new RepDeactivation();
    deactivation.newRepId = this.newRepId();
    deactivation.cancelDate = DateUtils.formatOutput(this.cancelDate());
    this.dialogRef.close(deactivation);
  }

}
